import React, { useMemo, useState } from 'react'
import PropTypes from 'prop-types'
import { useQueryClient } from '@tanstack/react-query'
import SydButton from '../../../../../commonDesign/Button'
import { useAssociateImage, useImageUpload } from '../../../../../../api/media'
import ImageInput from '../../../media/ImageInput'
import { QUERY_KEYS } from '../../../../../../api/queryKeys'

function LibraryUploader ({
  onClose,
  purposeId,
  statusId
}) {
  const queryClient = useQueryClient()
  const [imageData, setImageData] = useState(null)
  const {
    mutateAsync: uploadImage,
    isLoading: isLoadingUploadImage,
    error: isErrorUploadImage
  } = useImageUpload({ waitForProcessingComplete: true })
  const {
    mutateAsync: associateImage,
    isLoading: isLoadingAssociateImage,
    error: isErrorAssociatingImage
  } = useAssociateImage()

  const isLoading = useMemo(() => isLoadingUploadImage || isLoadingAssociateImage, [isLoadingUploadImage, isLoadingAssociateImage])
  const error = useMemo(() => isErrorUploadImage || isErrorAssociatingImage, [isErrorUploadImage, isErrorAssociatingImage])

  const handleUploadImage = async (file) => {
    const uploadResult = await uploadImage({
      file: imageData.file,
      fileName: imageData.name,
      displayName: imageData.displayName || 'Status Icon'
    })

    await associateImage({
      imageId: uploadResult.image.imageId,
      purposeId: purposeId,
      levelTypeId: 279,
      levelId: statusId
    })
    await queryClient.invalidateQueries({ queryKey: [QUERY_KEYS.statusReportStatuses, statusId] })
    onClose?.()
  }

  return (
    <div className='flex-1'>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '12px' }}>
        <div className='font-bold font-size-sm'>Upload New Icon</div>
        <SydButton
          variant='secondary'
          processing={isLoading}
          disabled={isLoading}
          size='sm'
          onClick={() => {
            setImageData(null)
            onClose?.()
          }}
        >
          Back
        </SydButton>
      </div>

      {error && (
        <div className='text-danger-700 font-size-sm'>
          Error associating image: {error.message}
        </div>
      )}

      <ImageInput
        value={imageData}
        onChange={setImageData}
        processing={isLoading}
        acceptFiles={['image/jpeg', 'image/jpg', 'image/png', 'image/svg+xml']}
        minHeight='150px'
      />

      <div style={{ marginTop: '12px' }}>
        <div className='opacity-lowlighted font-size-xs'>
          Recommended: 128x128px, JPG/PNG/SVG, max 500KB
        </div>
      </div>

      {imageData?.file && (
        <div style={{ marginTop: '16px' }}>
          <SydButton
            variant='primary'
            onClick={handleUploadImage}
            disabled={isLoading}
            processing={isLoading}
            fullWidth
          >
            Upload & Associate Icon
          </SydButton>
        </div>
      )}
    </div>
  )
}

LibraryUploader.propTypes = {
  onClose: PropTypes.func,
  statusId: PropTypes.number,
  purposeId: PropTypes.number
}

export default LibraryUploader
